import { getBlackListedStatus } from "apiHelpers/api/ApiHelpers";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { UTILS } from "utils";
import { useHistory } from "react-router-dom";
import C from "Constants";

function useCurrentUser() {
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const { DomainType } = useSelector((state) => state.AppReducer);
  const [currentUser, setUser] = useState({});
  const calledRef = useRef(false);
  const history = useHistory();

  useEffect(() => {
    if (!calledRef.current) {
      calledRef.current = true;
      checkBlacklistedStatus();
    }
  }, []);

  const checkBlacklistedStatus = async () => {
    const searchParams = new URLSearchParams(window?.location?.search);
    const apiKey = searchParams.get("apiKey");
    if(apiKey) return
    try {
      const response = await getBlackListedStatus();
      if (response?.data?.isBlacklisted) {
        const pathname = DomainType === C.CUSTOM_DOMAIN 
          ? "/blocked" 
          : `/${brandInfo?.setting?.temporaryDomainName || window.location.pathname.split('/')[1]}/blocked`;
        history.replace(pathname);
      }
    } catch (error) {
      console.error("Error checking blacklisted status:", error);
    }
  };

  const setUserInfo = () => {
    const user = UTILS.getCurrentUser(brandInfo?.brand?._id);
    if (user) setUser(user);
  };

  useEffect(() => {
    if (brandInfo?.brand?._id) {
      setUserInfo();
    }
  }, [brandInfo?.brand?._id]);

  return {
    currentUser,
    setUserInfo,
  };
}

export default useCurrentUser;
